import React from "react";

import estilo from "./styles/Pagina.module.css";

import Video from "./components/Vivo";

function App() {
  return (
    <div className={estilo.pagina}>
      <Video></Video>
    </div>
  );
}

export default App;
